import Skeleton from "react-loading-skeleton";
import * as React from "react";

export const SkeletonAccordionBodyItem = () => (
    <>
        <Skeleton height={25}/>
        <small className="text-muted d-block mt-1">
            <Skeleton count={3 + Math.random()}/>
        </small>
        <hr/>
    </>
);